"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function FormChannelsSuperAdmin(_a) {
    var user = _a.user, setUser = _a.setUser;
    var sports = ra_fetch_1.useApi('backend').index('sports', { channels: 1 })[0];
    var _b = react_1.useState([]), sportIds = _b[0], setSportIds = _b[1];
    var _c = react_1.useState([]), channels = _c[0], setChannels = _c[1];
    function sport(sportIds) {
        setSportIds(sportIds);
        var collection = [];
        sportIds.forEach(function (sport_id) {
            collection = collection.concat(sports.data.findBy('id', Number(sport_id)).channels || []);
        });
        setChannels(collection);
    }
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Forms.Title, null, "Nieuw kanaal"),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Users.FormRole, { value: user.role_id, setUser: setUser })),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Select, { multiple: true, name: 'sports', value: sportIds, onChange: sport },
                react_1.default.createElement("option", { value: '' }, "Kies sporten"),
                sports.data.sortBy('label').map(function (role) {
                    return react_1.default.createElement("option", { key: role.id, value: role.id }, role.label);
                }))),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Select, { multiple: true, name: 'channels', value: user.channels, onChange: function (channels) { return setUser({ channels: channels }); } },
                react_1.default.createElement("option", { value: '' }, Boolean(sportIds.length) ? 'Kies kanalen' : 'Kies eerst sporten'),
                channels.sortBy('label').map(function (role) {
                    return react_1.default.createElement("option", { key: role.id, value: role.id }, role.label);
                }))));
}
exports.default = FormChannelsSuperAdmin;
